import * as React from "react";
import { connect } from "react-redux";
import { loadHandrailHandles } from "../../loader";
import { dt } from "webc-reactcore/src/js/stores/GlobalStore";
import { toSelectItems, createTitlePortalCollapsibleLanguageField, createDescriptionPortalCollapsibleLanguageField, createApiTitlePortalCollapsibleLanguageField, createApiDescriptionPortalCollapsibleLanguageField } from "./helper";
import MultiLanguageString from "orbiter-core/src/datastructures/languages/MultiLanguageString";
import SimpleSettingsTemplate from "./SimpleSettingsTemplate";
import ConfigBlock from "../../components/ConfigBlock";
import HandrailHandleAPI from "../../apicontroller/staircasedata/HandrailHandleAPI";
import HandrailHandle from "../../../../../shared/datastructures/staircasedata/HandrailHandle";
import InfoScreen from "../../components/InfoScreen";
import { t } from "ttag";
import ImagePreviewUploadZone from "../../components/ImagePreviewUploadZone";

@(connect((store: any) => {
    return { settings: { ...store.settings }, globalInformation: { ...store.globalInformation } };
}) as any)
export default class HandrailHandleSettings extends React.Component<any, any> {

    public handrailHandlesToSelectItems() {
        return toSelectItems<HandrailHandleAPI>("handrailhandle", this.props.globalInformation.handrailHandles.sort((x, y) => dt(x.getTitle()) < dt(y.getTitle()) ? -1 : 1), (x) => HandrailHandleAPI.clone(x), (x) => dt(x.getTitle()));
    }

    private async createEmpty(): Promise<HandrailHandle> {
        return new HandrailHandle(new MultiLanguageString(), new MultiLanguageString());
    }

    private async create(data: HandrailHandle) {
        await HandrailHandleAPI.create(data);
    }

    public render() {
        return <SimpleSettingsTemplate
            title="Handgrepen"
            selectItems={this.handrailHandlesToSelectItems()}

            reload={loadHandrailHandles.bind(this)}
            createEmpty={this.createEmpty.bind(this)}
            create={this.create.bind(this)}
            clone={(i: HandrailHandleAPI) => HandrailHandleAPI.clone(i)}

            renderEdit={this.renderEdit.bind(this)}
            renderCreate={this.renderCreate.bind(this)}

            infoScreen={<InfoScreen title={t`Selecteer een handgreep.`} image={"/cdn/images/pole.svg"}/>}
        />;
    }


    private renderEdit(a: HandrailHandleAPI, setSelected: (i: HandrailHandleAPI) => void) {
        return this.doRender(
            createApiTitlePortalCollapsibleLanguageField(a, (x) => HandrailHandleAPI.clone(x), setSelected.bind(this)),
            createApiDescriptionPortalCollapsibleLanguageField(a, (x) => HandrailHandleAPI.clone(x), setSelected.bind(this)),
            <ImagePreviewUploadZone
                imagePreviewIds={a.getImagePreviewIds()}
                onChange={(imagePreviewIds: string[]) => {
                    const cl: HandrailHandleAPI = HandrailHandleAPI.clone(a);
                    cl.getData().setImagePreviewIds(imagePreviewIds);
                    setSelected(cl);
                }}
            />,
        );
    }

    private renderCreate(a: HandrailHandle, setSelected: (i: HandrailHandle) => void) {
        return this.doRender(
            createTitlePortalCollapsibleLanguageField(a, setSelected.bind(this)),
            createDescriptionPortalCollapsibleLanguageField(a, setSelected.bind(this)),
            <ImagePreviewUploadZone
                imagePreviewIds={a.getImagePreviewIds()}
                onChange={(imagePreviewIds: string[]) => {
                    const cl: HandrailHandle = a.clone();
                    cl.setImagePreviewIds(imagePreviewIds);
                    setSelected(cl);
                }}
            />,
        );
    }

    private doRender(
        titlePCLF: React.ReactNode,
        descriptionPCLF: React.ReactNode,
        imagePreviewMI: React.ReactNode,
    ): React.ReactNode {
        return <div className={"container-fluid"}>
            <div className="row">
                <div className="col-md-6">
                    <ConfigBlock
                        title="Titel"
                        description="Geef een titel in voor deze handgreep."
                        topMost={true}
                    >
                        {titlePCLF}
                    </ConfigBlock>

                    <ConfigBlock
                        title="Afbeeldingen"
                        description="Upload afbeeldingen waarop deze handgreep te zien is."
                        topMost={false}
                    >
                        {imagePreviewMI}
                    </ConfigBlock>
                </div>
                <div className="col-md-6">
                    <ConfigBlock
                        title="Omschrijving"
                        description="Geef een omschrijving in voor deze handgreep."
                        topMost={true}
                    >
                        {descriptionPCLF}
                    </ConfigBlock>
                </div>
            </div>
        </div>;
    }

}
